import { Component, OnInit, OnDestroy } from "@angular/core";
import { DataService_photomaint } from "../shared/data.service";
import { wsImageStagingQueueInfo } from "../shared/wsImageStagingQueueInfo";
import { wsPersonPhotoEditInfo } from "../shared/wsPersonPhotoEditInfo";
import { wsPersonPhotoEditUploadInfo } from "../shared/wsPersonPhotoEditUploadInfo";
import { wsAiColorPickerParmInfo, wsAiColorPickerInfo, wsAiPresetColorInfo } from "../shared/wsPhotoAIColorPresetInfo";
import { wsPhotoAIUploadInfo } from "../shared/wsPhotoAIUploadInfo";

import { ColorPickerComponent, ColorPickerModule } from 'ngx-color-picker';
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";
import { ImageCroppedEvent, ImageTransform } from "ngx-image-cropper"; // https://github.com/Mawi137/ngx-image-cropper

@Component({
	selector: "app-root",
	templateUrl: "./photoedit.component.html",
	styleUrls: ["./photoedit.component.css"],
})
export class PhotoEditComponent implements OnInit, OnDestroy {
	constructor(private dataService: DataService_photomaint, public ref: DynamicDialogRef, public dialogConfig: DynamicDialogConfig) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	public isLoaded: boolean = false;

	public isAiShowColorPicker: boolean = false;
	public isAiProcessing: boolean = false;
	public isAiProcessed: boolean = false;
	
	public AiBackgroundColor: string = "#FFFFFF";
	public AiPresetColors: string[] = [];
	
	public AiResetImage: string;

	public SelectedSchool: any;

	public ImageStagingQueueItem: wsImageStagingQueueInfo;
	public PersonSelecterPersonID: number = -1;
	public isEditPhotoInCAASS: boolean = false;

	public cropperImageBase64: any = "";
	public cropperCroppedImage: any = "";
	public cropperCroppedWorkImage: any = "";
	public cropperMaintainAspectRatio: boolean = false;
	public cropperAspectRatio: number = 1.0;
	public cropperCanvasRotation: number = 0.0;
	public cropperTransform: ImageTransform = {};

	public isCustom: boolean = true;
	public isLandscape: boolean = false;
	public isPortrait: boolean = false;

	public filterGrayscale: boolean = false;
	public filterBrightness: number = 0.0;
	public filterContrast: number = 0.0;

	// https://www.html5rocks.com/en/tutorials/canvas/imagefilters/

	//	Image Processing
	private ImageEditUpload: wsPersonPhotoEditUploadInfo[] = [];

	public PersonPhotoEdit: wsPersonPhotoEditInfo = {
		ImageStagingQueueID: "",
		PersonID: -1,
		DefaultAIColor: "",
		ImageData_Normal: "",
		ImageData_Raw: "",
	};

	public AiColorPicker: wsAiColorPickerInfo = {
		SchoolID: -1,
		DefaultAIColor: "",
		PresetAIColorList: []
	}; 

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.SelectedSchool = this.dialogConfig.data.SelectedSchool;
		this.ImageStagingQueueItem = this.dialogConfig.data.ImageStagingQueueItem;
		this.PersonSelecterPersonID = this.dialogConfig.data.PersonSelecterPersonID;

		if (this.dialogConfig.data.PersonSelecterPersonID > 0) {
			this.isEditPhotoInCAASS = true;
		}

		//
		//	Get The Photo To Edit From CAASS or Staging Queue
		//
		if (this.isEditPhotoInCAASS == true) {
			let parms: wsPersonPhotoEditInfo = {
				ImageStagingQueueID: "",
				PersonID: this.PersonSelecterPersonID,
				DefaultAIColor: "",
				ImageData_Normal: "",
				ImageData_Raw: "",
			};

			this.dataService.PersonPhotoEditGet(parms).subscribe((data) => this.PersonPhotoEditGet_Complete(data));
		} else {
			let parms: wsPersonPhotoEditInfo = {
				ImageStagingQueueID: this.ImageStagingQueueItem.ImageStagingQueueID,
				PersonID: -1,
				DefaultAIColor: "",
				ImageData_Normal: "",
				ImageData_Raw: "",
			};

			this.dataService.PersonPhotoEditGet(parms).subscribe((data) => this.PersonPhotoEditGet_Complete(data));
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------

	ngOnDestroy() {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	PersonPhotoEditGet_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	PersonPhotoEditGet_Complete(data: any) {
		this.isLoaded = true;
		this.PersonPhotoEdit = data;

		this.AiBackgroundColor = this.PersonPhotoEdit.DefaultAIColor;
		this.cropperImageBase64 = this.PersonPhotoEdit.ImageData_Normal;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onCustom
	//
	//-----------------------------------------------------------------------------------------------------
	onCustom() {
		this.isCustom = true;
		this.isPortrait = false;
		this.isLandscape = false;
		this.cropperMaintainAspectRatio = false;
		this.cropperAspectRatio = 1.0 / 1.0;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onPortrait
	//
	//-----------------------------------------------------------------------------------------------------
	onPortrait() {
		this.isCustom = false;
		this.isPortrait = true;
		this.isLandscape = false;
		this.cropperMaintainAspectRatio = true;
		this.cropperAspectRatio = 3.0 / 4.0;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onLandscape
	//
	//-----------------------------------------------------------------------------------------------------
	onLandscape() {
		this.isCustom = false;
		this.isPortrait = false;
		this.isLandscape = true;
		this.cropperMaintainAspectRatio = true;
		this.cropperAspectRatio = 4.0 / 3.0;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRotateCanvas
	//
	//-----------------------------------------------------------------------------------------------------
	onRotateCanvas() {
		let newRotation = this.cropperCanvasRotation + 1; // 0=0°, 1=90°, 2=180°, 3=270°

		if (newRotation > 3) {
			newRotation = 0;
		}

		this.cropperCanvasRotation = newRotation;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onFlipImageH
	//
	//-----------------------------------------------------------------------------------------------------
	onFlipImageH() {
		this.cropperTransform = {
			...this.cropperTransform,
			flipH: !this.cropperTransform.flipH,
		};
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onFlipImageV
	//
	//-----------------------------------------------------------------------------------------------------
	onFlipImageV() {
		this.cropperTransform = {
			...this.cropperTransform,
			flipV: !this.cropperTransform.flipV,
		};
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRestore
	//
	//-----------------------------------------------------------------------------------------------------
	onRestore() {
		this.cropperImageBase64 = this.PersonPhotoEdit.ImageData_Raw;
		this.filterGrayscale = false;
		this.filterBrightness = 0;
		this.filterContrast = 0;
		this.ApplyFilters();
		this.isAiProcessed = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onExport
	//
	//-----------------------------------------------------------------------------------------------------
	onExport() {
		const MAX_SIZE = 640;
		let _this = this;
		let img = document.createElement("img");

		img.onload = function () {
			let width = img.width;
			let height = img.height;

			if (width >= height) {
				// Landscape
				height = Math.round(img.height * (MAX_SIZE / img.width));
				width = MAX_SIZE;
			} else {
				// Portrait
				width = Math.round(img.width * (MAX_SIZE / img.height));
				height = MAX_SIZE;
			}

			let canvas = document.createElement("canvas");

			canvas.width = width;
			canvas.height = height;

			let ctx = canvas.getContext("2d");

			ctx.drawImage(img, 0, 0, width, height);

			let ExportImage: any = canvas.toDataURL("image/jpeg");

			const dlink: HTMLAnchorElement = document.createElement("a");
			dlink.download = "CAASSPhoto.jpg"; // the file name
			dlink.href = ExportImage;
			dlink.click(); // this will trigger the dialog window
			dlink.remove();
		};

		img.src = this.cropperCroppedWorkImage;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	cropperImageLoaded
	//
	//-----------------------------------------------------------------------------------------------------
	cropperImageLoaded(image: any) {
		this.isLoaded = true;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	cropperReady
	//
	//-----------------------------------------------------------------------------------------------------
	cropperReady() {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	cropperLoadImageFailed
	//
	//-----------------------------------------------------------------------------------------------------
	cropperLoadImageFailed() {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	cropperImageCropped
	//
	//-----------------------------------------------------------------------------------------------------
	cropperImageCropped(event: ImageCroppedEvent) {
		var ImgData = "";

		if (event.base64 != undefined) {
			ImgData = event.base64;
		} else if (event.objectUrl != undefined) {
			ImgData = event.objectUrl;
		}

		this.cropperCroppedImage = ImgData;
		this.cropperCroppedWorkImage = ImgData;
		this.ApplyFilters();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	setGrayscaleValue
	//
	//-----------------------------------------------------------------------------------------------------
	setGrayscaleValue(event: any) {
		this.ApplyFilters();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	setBrightnessValue
	//
	//-----------------------------------------------------------------------------------------------------
	setBrightnessValue(event: any) {
		this.ApplyFilters();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	setContrastValue
	//
	//-----------------------------------------------------------------------------------------------------
	setContrastValue(event: any) {
		this.ApplyFilters();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ApplyFilters
	//
	//-----------------------------------------------------------------------------------------------------
	ApplyFilters() {
		let _this = this;
		let img = document.createElement("img");

		img.onload = function () {
			let canvas = document.createElement("canvas");

			canvas.width = img.width;
			canvas.height = img.height;

			let ctx = canvas.getContext("2d");

			ctx!.drawImage(img, 0, 0);

			let imageData = ctx!.getImageData(0, 0, Number(img.width), Number(img.height));
			let data = imageData.data;

			if (_this.filterGrayscale == true) {
				_this.applyGrayscale(data);
			}
			_this.applyBrightness(data, _this.filterBrightness);
			_this.applyContrast(data, _this.filterContrast);

			ctx!.putImageData(imageData, 0, 0);

			_this.cropperCroppedWorkImage = canvas.toDataURL("image/jpeg");
		};

		img.src = this.cropperCroppedImage;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	applyGrayscale
	//
	//-----------------------------------------------------------------------------------------------------
	applyGrayscale(data: any) {
		var d = data;
		for (var i = 0; i < d.length; i += 4) {
			var r = d[i];
			var g = d[i + 1];
			var b = d[i + 2];
			// CIE luminance for the RGB
			// The human eye is bad at seeing red and blue, so we de-emphasize them.
			var v = 0.2126 * r + 0.7152 * g + 0.0722 * b;
			d[i] = d[i + 1] = d[i + 2] = v;
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	applyBrightness
	//
	//-----------------------------------------------------------------------------------------------------
	applyBrightness(data: any, brightness: number) {
		for (var i = 0; i < data.length; i += 4) {
			data[i] += 255 * (brightness / 100);
			data[i + 1] += 255 * (brightness / 100);
			data[i + 2] += 255 * (brightness / 100);
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	applyContrast
	//
	//-----------------------------------------------------------------------------------------------------
	applyContrast(data: any, contrast: number) {
		var factor = (259.0 * (contrast + 255.0)) / (255.0 * (259.0 - contrast));

		for (var i = 0; i < data.length; i += 4) {
			data[i] = this.truncateColor(factor * (data[i] - 128.0) + 128.0);
			data[i + 1] = this.truncateColor(factor * (data[i + 1] - 128.0) + 128.0);
			data[i + 2] = this.truncateColor(factor * (data[i + 2] - 128.0) + 128.0);
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onBrightnessReset
	//
	//-----------------------------------------------------------------------------------------------------
	onBrightnessReset() {
		this.filterBrightness = 0;
		this.ApplyFilters();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onContrastReset
	//
	//-----------------------------------------------------------------------------------------------------
	onContrastReset() {
		this.filterContrast = 0;
		this.ApplyFilters();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onAIReset
	//
	//-----------------------------------------------------------------------------------------------------
	onAIReset() {
		this.cropperImageBase64 = this.AiResetImage;
		this.isAiProcessed = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onAiRemoveBackground
	//
	//-----------------------------------------------------------------------------------------------------
	onAiRemoveBackground() {
		this.isAiProcessing = true;
		this.AiResetImage = this.cropperImageBase64;
		this.ApplyRemoveBackground();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ApplyRemoveBackground
	//
	//-----------------------------------------------------------------------------------------------------
	ApplyRemoveBackground() {
		let parms: wsPhotoAIUploadInfo = {
			BackgroundColor: this.AiBackgroundColor.toUpperCase(),
			PersonPhoto: this.cropperImageBase64
		};

		this.dataService.PhotoAIRemoveBackground(parms).subscribe((data) => this.ApplyRemoveBackground_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ApplyRemoveBackground_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	ApplyRemoveBackground_Complete(data: any) {

		let rPhotoAIRemoveBackGroundInfo: wsPhotoAIUploadInfo = data;
		let PhotoBackgroundImage = rPhotoAIRemoveBackGroundInfo.PersonPhoto;

		this.PersonPhotoEdit.ImageData_Normal = PhotoBackgroundImage;
		this.cropperImageBase64 = this.PersonPhotoEdit.ImageData_Normal;
		
		this.isAiProcessing = false;
		this.isAiProcessed = true;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onAiCreatePortrait
	//
	//-----------------------------------------------------------------------------------------------------
	onAiCreatePortrait() {
		this.isAiProcessing = true;
		this.AiResetImage = this.cropperImageBase64;
		this.ApplyCreatePortrait();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ApplyCreatePortrait
	//
	//-----------------------------------------------------------------------------------------------------
	ApplyCreatePortrait() {
		let parms: wsPhotoAIUploadInfo = {
			BackgroundColor: this.AiBackgroundColor.toUpperCase(),
			PersonPhoto: this.cropperImageBase64
		};

		this.dataService.PhotoAICreatePortrait(parms).subscribe((data) => this.ApplyCreatePortrait_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ApplyCreatePortrait_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	ApplyCreatePortrait_Complete(data: any) {
		let rPhotoAIRemoveBackGroundInfo: wsPhotoAIUploadInfo = data;
		let PhotoBackgroundImage = rPhotoAIRemoveBackGroundInfo.PersonPhoto;

		this.PersonPhotoEdit.ImageData_Normal = PhotoBackgroundImage;
		this.cropperImageBase64 = this.PersonPhotoEdit.ImageData_Normal;
		
		this.isAiProcessing = false;
		this.isAiProcessed = true;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	truncateColor
	//
	//-----------------------------------------------------------------------------------------------------
	truncateColor(value: number) {
		if (value < 0) {
			value = 0;
		} else if (value > 255) {
			value = 255;
		}

		return value;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSave
	//
	//-----------------------------------------------------------------------------------------------------
	onSave() {
		this.ResizeImageAndUpload();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ResizeImageAndUpload
	//
	//-----------------------------------------------------------------------------------------------------
	ResizeImageAndUpload() {
		const MAX_SIZE = 640;

		let _this = this;
		let img = document.createElement("img");

		img.onload = function () {
			let width = img.width;
			let height = img.height;

			if (width >= height) {
				// Landscape
				height = Math.round(img.height * (MAX_SIZE / img.width));
				width = MAX_SIZE;
			} else {
				// Portrait
				width = Math.round(img.width * (MAX_SIZE / img.height));
				height = MAX_SIZE;
			}

			let canvas = document.createElement("canvas");

			canvas.width = width;
			canvas.height = height;

			let ctx = canvas.getContext("2d");

			ctx.drawImage(img, 0, 0, width, height);

			let obj: wsPersonPhotoEditUploadInfo = {
				isInCAASS: _this.isEditPhotoInCAASS,
				ImageStagingQueueID: _this.PersonPhotoEdit.ImageStagingQueueID,
				PersonID: _this.PersonPhotoEdit.PersonID,
				ImageData_Normal: canvas.toDataURL("image/jpeg"),
			};

			_this.ImageEditUpload.push(obj);

			//
			//	Upload Edited Image
			//
			console.log("Starting image edit upload..", new Date().toLocaleTimeString("en-US"));
			_this.dataService.PersonPhotoEditUpload(_this.ImageEditUpload[0]).subscribe((data) => _this.PersonPhotoEditUpload_Callback(data));
		};

		img.src = this.cropperCroppedWorkImage;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	UploadImage_Callback
	//
	//-----------------------------------------------------------------------------------------------------
	PersonPhotoEditUpload_Callback(data: any) {
		console.log("Image edit upload complete..", new Date().toLocaleTimeString("en-US"));
		//
		// 0 = CANCEL
		// 1 = Save Staging Queue Image
		// 2 = Save CAASS Image
		//
		if (this.isEditPhotoInCAASS == true) {
			this.ref.close(2);
		} else {
			this.ref.close(1);
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onClose
	//
	//-----------------------------------------------------------------------------------------------------
	onClose() {
		//
		// 0 = CANCEL
		// 1 = Save Staging Queue Image
		// 2 = Save CAASS Image
		//
		this.ref.close(0);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onColorPickerOpen
	//
	//-----------------------------------------------------------------------------------------------------
	onColorPickerOpen() {
		let parms: wsAiColorPickerParmInfo = {
			SchoolID: this.SelectedSchool.SchoolID
		};

		this.dataService.AIColorPickerGet(parms).subscribe((data) => this.onColorPickerOpen_Complete(data));		
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onColorPickerOpen
	//
	//-----------------------------------------------------------------------------------------------------
	onColorPickerOpen_Complete(data: any) {
		this.AiColorPicker = data;
		
		 if (this.AiColorPicker.PresetAIColorList.length > 0)
		 {
		 	var AiColors: string[] = [];

 		 	this.AiColorPicker.PresetAIColorList.forEach((value) => {
		 		AiColors = [...AiColors, value.Color];
		 	});  

		 	this.AiBackgroundColor = this.AiColorPicker.DefaultAIColor;
		 	this.AiPresetColors = (JSON.parse(JSON.stringify(AiColors)));
		 }
		
		this.isAiShowColorPicker = true;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onColorPickerOk
	//
	//-----------------------------------------------------------------------------------------------------
	onColorPickerOk() {
		var PresetAIColorList: wsAiPresetColorInfo[] = [];
		
		this.AiPresetColors.forEach((value) => {
			let AiColor: wsAiPresetColorInfo = {Color: value};
			
			if (AiColor.Color.substring(0,1) != "#")
			{
				//
				//	User Added Colors return a string 'rgb(xxx,xxx,xxx)' in decimal not '#xxxxxx' in HEX.
				//	We must convert to a HEX string.
				//
				let rgbValues = AiColor.Color
				.substring(4, AiColor.Color.length - 1)
				.split(",")
				.map(Number);				

				let hexColor = this.rgbToHex(rgbValues[0],rgbValues[1],rgbValues[2]);
				AiColor.Color = hexColor;

			}
			
			PresetAIColorList = [...PresetAIColorList, AiColor];
			
	   	}); 

		let parms: wsAiColorPickerInfo = {
			SchoolID: this.SelectedSchool.SchoolID,
			DefaultAIColor: this.AiBackgroundColor,
			PresetAIColorList: PresetAIColorList
		};

		//
		// Update Presets in CAASS and Set Default
		//
		this.dataService.AIColorPickerUpdate(parms).subscribe((data) => this.onColorPickerOk_Complete(data));	
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	rgbToHex
	//
	//-----------------------------------------------------------------------------------------------------	
	rgbToHex(r: number, g: number, b: number): string {
		return "#" + this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b);
	}
	  
	//-----------------------------------------------------------------------------------------------------
	//
	//	componentToHex
	//
	//-----------------------------------------------------------------------------------------------------	
	componentToHex(c: number): string {
		const hex = c.toString(16);
		return hex.length === 1 ? "0" + hex : hex;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onColorPickerOk_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	onColorPickerOk_Complete(data: any) {
		this.isAiShowColorPicker = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onColorPickerCancel
	//
	//-----------------------------------------------------------------------------------------------------
	onColorPickerCancel() {
		this.AiBackgroundColor = this.AiColorPicker.DefaultAIColor;
		this.isAiShowColorPicker = false;
	}	
}
